import './sources.css';
import { Source } from '../../../types/interfaces';

export class Sources {
    draw(data: Array<Source>):void {
        const fragment = document.createDocumentFragment() as DocumentFragment;
        const sourceItemTemp = document.querySelector('#sourceItemTemp') as HTMLTemplateElement;
        
        data.forEach((item): void => {
          const sourceClone = sourceItemTemp.content.cloneNode(true) as DocumentFragment;

          (sourceClone.querySelector('.source__item-name') as HTMLTemplateElement).textContent = item.name;
          (sourceClone.querySelector('.source__item') as HTMLTemplateElement).setAttribute('data-source-id', item.id);

          fragment.append(sourceClone);
        });

        (document.querySelector('.sources') as HTMLTemplateElement).append(fragment);
    }
}